<div class="content-dialog">
    <div class="row mt-2 mb-5 mb-md-4">
        <div class="col-12">
            <p class="text-center text-color-primary font-semi-bold" style="font-size: 16px;">¿Cómo encontrar tu número de cliente?</p>
        </div>
        <div class="col-12 content-scroll">
            <div class="content-column p-4">
                <img style="width: 100%;" src="./assets/img/invoice-view.png" alt="">
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-12 text-center">
            <button mat-dialog-close mat-flat-button class="style-button-1 mt-2 w-30">
                <span>Entendido</span>
            </button>
        </div>
    </div>
</div>
